var style = {"z-label":"z-label","z-legend":"z-legend","z-label--side":"z-label--side","z-legend--side":"z-legend--side","z-label--required":"z-label--required","z-legend--required":"z-legend--required","z-label__optional":"z-label__optional"};

export { style as default };
//# sourceMappingURL=labelAndLegend.module.scss.js.map
